import { Component, OnInit, Input } from '@angular/core';

import {RootScopeService} from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';

@Component({
  selector: 'app-heatmap-legend',
  templateUrl: './heatmap-legend.component.html',
  styleUrls: ['./heatmap-legend.component.css']
})
export class HeatmapLegendComponent implements OnInit {

  @Input() selectedFloorName: string;
  isLegendVisible = false;

  rootScopeData: RootScopeDeclare;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }
  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  ngOnInit() {
    if (!(this.rootScopeData.deviceType === 'phone' || this.rootScopeData.deviceType === 'tablet')) {
      this.showLegend();
    }
  }

  showLegend() {
    this.isLegendVisible = true;
  }

  hideLegend() {
    this.isLegendVisible = false;
  }

}
